module.exports = __webpack_public_path__ + "static/media/general-settings.5da8e396.png";